import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { BaseDto } from '../../base/dtos/base.dto';
import { StatusTrackingScopeEnum } from '../enums/status-tracking-scope.enum';

/**
 * Status tracking DTO
 */
export class StatusTrackingDto<T> extends BaseDto {
	sourceSubject!: AppSubjectEnum;
	sourceId!: number;
	targetSubject!: AppSubjectEnum;
	targetId!: number;
	status!: T;
	scope!: StatusTrackingScopeEnum;
	effectiveFrom!: Date;
	effectiveTo?: Date;
	priority!: number;
}
